import Swiper from 'swiper';
import SwiperCore, { Navigation, Scrollbar } from 'swiper/core';
import debounce from 'lodash/debounce';
import 'swiper/css';
import 'swiper/css/scrollbar';
SwiperCore.use([Navigation, Scrollbar]);

export default class CollectionBannerCarousel {
    /**
        * Class constructor *
        * @arg {object} - `sliderElement` check for the
        * collections banner carousel element.
    **/
    constructor (sliderElement) {
        if (!sliderElement) return;

        this.sliderElement = sliderElement;
        this.swiperScrollbar = this.sliderElement.querySelector('.swiper-scrollbar')
        this.slidesLength = this.sliderElement.querySelectorAll('.js-slide').length;
        this.swiper = null;
        this.handleResize = debounce(() => {
            this.updateSwiperState();
        }, 100);

        window.addEventListener('resize', this.handleResize);
        this.init();
    }

    init() {
        this.updateSwiperState();
    }

    shouldEnableSwiper() {
        return this.slidesLength > 1 && this.isOverflowing();
    }

    isOverflowing() {
        const wrapper = this.sliderElement.querySelector('.swiper-wrapper');

        if (!wrapper) {
            return false;
        }

        return wrapper.scrollWidth > this.sliderElement.clientWidth + 1;
    }

    updateSwiperState() {
        if (this.shouldEnableSwiper()) {
            this.enableSwiper();
        } else {
            this.disableSwiper();
        }
    }

    enableSwiper() {
        if (this.swiper) {
            this.swiper.update();
            return;
        }

        if (this.swiperScrollbar) {
            this.swiperScrollbar.classList.remove('hidden');
        }

        this.swiper = new Swiper(this.sliderElement, {
            slidesPerView: 'auto',
            spaceBetween: 8,
            threshold: 10,
            navigation: {
                nextEl: this.sliderElement.querySelector('.swiper-button-next'),
                prevEl: this.sliderElement.querySelector('.swiper-button-prev')
            },
            scrollbar: {
                el: this.swiperScrollbar,
                hide: false,
                draggable: true,
            }
        });
    }

    disableSwiper() {
        if (this.swiper) {
            this.swiper.destroy(true, true);
            this.swiper = null;
        }

        if (this.swiperScrollbar) {
            this.swiperScrollbar.classList.add('hidden');
        }
    }
}
